export const DASHBOARD_ENTITY_NAME = 'app.settings.user.settings.dashboards';
